import { Mapper } from './mapper';

export const TipoContrato = Mapper.from([
  [1, 'Prazo indeterminado'],
  [2, 'Prazo determinado, definido em dias'],
  // [3,'Prazo determinado, vinculado à ocorrência de um fato'],
]);
